import { RegionMenuSettingRepository } from '../../domain/repositories/RegionMenuSettingRepository'
import { RegionMenuSettingModel } from '../models/RegionMenuSettingModel'
import type { RegionMenuSettingEntity } from '../../domain/entities/RegionMenuSettingEntity'
import type { RegionScreenToggleEntity } from '../../domain/entities/RegionScreenToggleEntity'
import { RegionMenuSettingsService } from '@/backend/market'

export class RegionMenuSettingRepositoryImpl implements RegionMenuSettingRepository {
  async getRegionMenuSetting(
    regionId: number
  ): Promise<RegionMenuSettingEntity | { error: true }> {
    try {
      const response = await RegionMenuSettingsService.getRegionMenuSettingAdmin({ regionId })
      return new RegionMenuSettingModel(response)
    } catch {
      return { error: true }
    }
  }
  async saveRegionMenuSetting(
    regionId: number,
    screens: RegionScreenToggleEntity[]
  ): Promise<RegionMenuSettingEntity | { error: true }> {
    try {
      const response = await RegionMenuSettingsService.upsertRegionMenuSettingAdmin({
        regionId,
        requestBody: {
          screens: screens.map((screen) => ({
            menuScreenId: screen.menuScreenId ?? '',
            isEnabled: screen.isEnabled ?? true
          }))
        }
      })
      return new RegionMenuSettingModel(response)
    } catch {
      return { error: true }
    }
  }
  async resetRegionMenuScreen(
    regionId: number,
    menuScreenId: string
  ): Promise<RegionMenuSettingEntity | { error: true }> {
    try {
      const response = await RegionMenuSettingsService.deleteRegionMenuSettingAdmin({
        regionId,
        menuScreenId
      })
      return new RegionMenuSettingModel(response)
    } catch {
      return { error: true }
    }
  }
}
